import type { User } from '@xpanse/ui';

import { useQuery } from '@tanstack/react-query';

import { AuthService } from 'src/utils/services';

const getUser = async () => {
  const response = await AuthService.getUserId();
  return response;
};

export function useGetUserId(isAuthTokenSet: boolean) {
  const { data: user } = useQuery<User>({
    queryKey: ['user'],
    queryFn: getUser,
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    enabled: isAuthTokenSet,
  });

  return { user };
}
